import axios from 'axios'
import conf from './conf'
import {
  Message
} from 'element-ui'
const HOST = ''; //conf.HOSTS.LOCAL; //conf.HOSTS.IT4
var VUE = null

var extendObj = (source, ...extend) => {
  return Object.assign(source, ...extend)
}
// 允许跨域cookie共享
axios.defaults.withCredentials = true

const refreshToken = (res = {}) => {
  var headers = res.request.getAllResponseHeaders() || ''
  var reg = headers.match(new RegExp(`x-dm-user-token:[\\s]([^\\s]*)`))
  if (reg && reg[1]) {
    VUE.prototype.$utils.updateUseInfo({
      token: reg[1]
    })
  }
}
//添加一个请求拦截器---请求发出前
const interceptorsRequest = [function (config) {
  var user = VUE.prototype.$utils.isLogin()
  if (user) {
    config.headers['x-dm-user-token'] = user.token;
    config.headers['x-dm-timezone'] = VUE.prototype.$utils.getTimeZoneStr();
    config.headers['x-dm-lang'] = VUE.prototype.$utils.getAppLang();
  }
  return config;
}, function (err) {
  Message.error({
    message: '请求超时'
  })
  Promise.resolve({
    error: true,
    _err: err
  })
  // return Promise.reject(error);
}];

//添加一个响应拦截器
const interceptorsResponse = [function (res) {
  res.config = res.config || {};
  if (/\/get-check-code$/.test(res.config.url || '')) { // 获取验证码格式不同，单独处理
    res.data = {
      data: res.data
    }
    if (res.data.data instanceof ArrayBuffer) {
      res.data.success = true
    } else {
      res.data.message = '验证码请求失败, 请重新尝试'
    }
  }
  if (/\/message\//.test(res.config.url || '')) { // 通知接口结构不同，单独处理，我也不想的。。。。
    if (!res.data.success) {
      if (!res.data.data) {
        res.data = {
          data: res.data,
          error: res.data.error || '',
          success: false
        }
      } else {
        res.data.success = true;
      }
    }
  }
  if (res.data.code == -1) {
    VUE.prototype.$message.info('登录失效,请重新登录');
    setTimeout(() => {
      VUE.prototype.$utils.logout();
    }, 2000);
    return {
      error: true
    };
  }
  let errorMsg = res.data.error || res.data.message || ''
  res.data = res.data || {}
  res.data._meta = res.config.params || {} // 请求信息
  if (!res.data.success) {
    res.data.error = true;
    Message.error(errorMsg || '网络错误，请稍后重试')
  }
  // 遍历查找是否更新token
  refreshToken(res)
  return res.data;
}, function (err = {}) {
  Message.error((err.toString && err.toString()) || '网络错误，请稍后重试');
  return Promise.resolve({
    error: true,
    _err: err
  })
}]


const baseConfig = {
  baseURL: `${HOST}/api/local/v1`,
  timeout: conf.TIMEOUT,
  headers: {
    'x-dm-user-token': '', // 判断是否登录
    'x-dm-timezone': '', //时区
    'x-dm-lang': '' //语言
  }
}
// product
const _axios = axios.create(baseConfig);
_axios.interceptors.request.use(...interceptorsRequest);
_axios.interceptors.response.use(...interceptorsResponse);

// mall
const _axiosMall = axios.create(extendObj(baseConfig, {
  baseURL: `${HOST}/api/mall/v1`,
}))
_axiosMall.interceptors.request.use(...interceptorsRequest);
_axiosMall.interceptors.response.use(...interceptorsResponse);

// 店小二验证
const noInterceptorAxios = axios.create(extendObj(baseConfig, {
  baseURL: `${HOST}/api/local/v1`,
}));


const API = {
  // 登录
  login(params) {
    return _axios.post('/business/login', params)
  },
  // 退出登录
  logout(params) {
    return _axios.post('/business/logout', params)
  },
  // 注册
  register(params) {
    return _axios.post('/business/register', params)
  },
  /**
   * 获取用户信息
   */
  getUserInfo() {
    return _axios.get('/business/get-user');
  },
  /**
   * 验证邮箱
   * @param {email} params 
   */
  checkEmailRepeat(params) {
    return _axios.get('/business/check-user-email', {
      params
    })
  },
  /**
   * @param userName
   */
  // 验证昵称
  checkUserNameRepeat(params) {
    return _axios.get('/business/check-user-name', {
      params
    })
  },
  // 获取图形验证码
  getCheckCode(params) {
    return _axios.get('/business/get-check-code', {
      params,
      responseType: 'arraybuffer'
    })
  },
  // 门店 -- 根据条件查询
  getStoresList(params) {
    return _axios.get('/business/bind/buss-search', {
      params
    })
  },
  // 门店 -- 创建门店
  createStore(params) {
    return _axios.post('/business/bind/submit-business', params)
  },
  // 门店 -- 更新门店信息
  updateStore(params) {
    return _axios.post('/business/bind/update', params)
  },
  // 提交结算信息
  submitAccount(params) {
    return _axios.post('/business/bind/submit-account', params)
  },
  // 认领门店
  claimStore(params) {
    return _axios.post('/business/bind/submit', params);
  },
  abortClaimStore(params) {
    return _axios.post('/business/bind/unbind-buss', params);
  },
  /**
   * 获取关联门店列表
   * @param {businessId}
   */
  getPublishBusinessList(params) {
    return _axios.get(`/voucher/publish-business-list`, {
      params
    })
  },
  // 查询商家结算信息by商家id -- 银行卡信息
  getAccountInfo(params) {
    return _axios.get(`/business/bind/get-account`, {
      params
    })
  },
  // 查询门店信息by门店id
  getSimpleStoreInfo(params) {
    return _axios.get(`/business/bind/get-simple-business`, {
      params
    })
  },
  // 查询门店信息by门店id
  getStoreInfo(params) {
    return _axios.get(`/business/bind/get-business`, {
      params
    })
  },
  // 发送重置密码的邮件
  sendResetEmail(params) {
    return _axios.post('/business/send-reset-email', params)
  },
  // 重置密码
  resetPassword(params) {
    return _axios.post('/business/reset-pass', params)
  },
  /**
   * 重置密码
   * @param {oldPass}
   * @param {pass}
   * @param {confirmPass}
   */
  updatePassword(params) {
    return _axios.post('/business/update-pass', params)
  },
  // /api/local/v1/business/update-pass
  /**
   * 查询账号已认领门店
   * @param { bussUserId }
   */
  getClaimedStore(params) {
    return _axios.get('/business/bind/get-binded-buss', {
      params
    })
  },
  // 查询商家所有门店
  getClaimStore(params) {
    return _axios.get('/business/bind/get-bind-buss', {
      params
    })
  },
  // 绑定当前门店
  bindStore(params) {
    return _axios.post('/business/bind-current-buss', params)
  },
  // 地区 -- 自定义地区
  getCities() {
    return _axios.get('/business/get-city-list')
  },
  // 城市 -- 具体城市
  getCounties(params) {
    return _axios.get('/business/get-county-list', {
      params
    })
  },
  // 获取分类
  getCategory(params) {
    return _axios.get(`/business/get-category-list?cityId=${params.cityId}`)
  },
  // 获取门店审核状态
  getRefreshBuss(params) {
    return _axios.get(`/business/bind/get-refresh-buss?businessId=${params.businessId}`)
  },
  // 通过代金券码获取对应代金券信息
  /**
   * serialNo,
   * businessId
   */
  //127.0.0.1:8082/api/mall/v1/voucher/getBySerialNo?serialNo=1992109593&businessId=194
  getVoucherBySerialNo(params) {
    return _axiosMall.get('/voucher/getBySerialNo', {
      params
    })
  },
  // 验券代金券
  /**
   * @param {id} -- orderGoodsId
   *"goodsGroupId": "",
   *"isGuest": false,
   *"code": 1650357786, // 用户输入密码
   *"businessId": 194, // 当前验券门店ID
   *"minusValue": 1000 // 面额
   */
  validateVoucher(params) {
    return _axiosMall.post('/goods/verify', params)
  },
  // 获取验券记录 -- 以具体每一笔为粒度
  /**
   * @param {startTime} 
   * endTime
   * sort
   */
  validateList(params) {
    // startTime=1523504185000&endTime=1528975708000&sort=-actual_minus_value
    return _axiosMall.get('/voucher/verifyReportDetail', {
      params
    })
  },
  // 获取验券记录  -- 以天为粒度
  /**
   * @param {startTime} 
   * endTime
   * sort
   */
  validateListDays(params) {
    // /api/mall/v1/voucher/verifyReport?startTime=1523504185000&endTime=1528975708000
    // sort-actual_minus_value
    return _axiosMall.get('/voucher/verifyReport', {
      params
    })
  },
  // 下载验券记录
  downloadValidatelist(params) {
    let url = _axiosMall.defaults.baseURL + '/voucher/exportVerifyReportDetail';
    let searchStr = '';
    var user = VUE.prototype.$utils.isLogin()
    if (user) {
      params['dm_token'] = user.token;
    }
    params.timezone = decodeURIComponent(VUE.prototype.$utils.getTimeZoneStr());
    for (var i in params) {
      searchStr += (searchStr ? '&' : '?') + i + '=' + (params[i] || '');
    }
    url += searchStr;
    window.open(url, '_blank');
    return new Promise(((resolve, reject) => {
      setTimeout(() => {
        resolve();
      }, 1000);
    }))
  },
  // 获取门店代金券列表
  getVouchedList(params) {
    return _axios.post('/voucher/list', params)
  },
  // 获取代金券详情
  getVouchedDetail(params) {
    return _axios.get(`/voucher/${params.id}`)
  },
  /**
   * @param businessId
   * @param page
   * @param size
   */
  getSettleRecords(params) {
    return _axiosMall.get('/business/settle/records', {
      params: params
    })
  },
  /**
   * 店小二--注册
   * @param userName
   * @param pass
   * @param email
   * @param token
   */
  assistantRegister(params) {
    return _axios.post('/assistant/register', params)
  },
  /**
   * 店小二--从邮件确认邀请
   * @param token
   */
  assistantVerify(params) {
    return noInterceptorAxios.get('/assistant/invitation/verify', {
      params
    })
  },
  /**
   * 店小二--店员列表
   * @param businessId
   */
  assistantList(params) {
    return _axios.get('/assistant/list', {
      params
    })
  },
  /**
   * 店小二--添加店员
   * @param businessId
   * @param email
   * @param firstName
   * @param lastName
   * @param privileges Array
   */
  assistantAdd(params) {
    return _axios.post('/assistant/add', params)
  },
  /**
   * 店小二--再次邀请
   * @param businessId
   * @param email
   */
  assistantAddAgain(params) {
    return _axios.post('/assistant/addAgain', params)
  },
  /**
   * 店小二--更新店员信息
   * @param businessId
   * @param assistantId
   * @param privileges
   * @param firstName
   * @param lastName
   * @param status // pedding--邀请中 delete-删除   normal-启用中 forbidden-未启动
   */
  updateAssistantInfo(params) {
    return _axios.post('/assistant/update', params)
  },
  /**
   * 移除店员
   * @param assistantId
   */
  deleteAssistant(params) {
    return _axios.post('/assistant/delete', params)
  },
  /**
   * 店小二--获取店员信息
   * @param businessId
   * @param assistantId
   */
  assistantInfo(params) {
    return _axios.post('/assistant/info', params)
  },
  /**
   * 店小二--获取权限配置
   */
  getPrivilegeConfig(params) {
    return _axios.get('/assistant/privilege', params)
  },
  /**
   * 微信登录
   * @param {code} 
   * @param {state}
   */
  wechatLogin(params) {
    return _axios.post('/business/wechat/pc-oauth-login', params);
  },
  /**
   * 微信登录后绑定邮箱，没有账号时初次登录
   * email
   * pass
   * type 'wechat_pc'
   *  unionId
   */
  wechatLoginAndBind(params) {
    return _axios.post('/business/wechat/bind-email', params);
  },
  /**
   * 微信解绑
   * type = 'wechat_pc'
   */
  wechatUnBind(params) {
    return _axios.post('/business/wechat/unbind', {
      type: 'wechat_pc'
    });
  },
  /**
   * 个人中心绑定微信
   * code
   * state
   */
  wechatLoginedAndBind(params) {
    return _axios.post('/business/wechat/pc-bind', params);
  },
  /**
   * 州列表
   */
  getStateList(params) {
    return _axios.get('/business/get-state-list');
  },
  /**
   * 获取经营概览数据
   */
  getSellingOverview(params) {
    return _axiosMall.get('/data-center/operation-overview', {
      params
    })
  },
  /**
   * 获取交易数据概览
   * @param {timeFrom}
   * @param {timeTo}
   */
  getTransOverview(params) {
    return _axiosMall.post('/data-center/trans-overview', params)
  },
  /**
   * 获取交易概览趋势图
   * @param {timeFrom}
   * @param {timeTo}
   * @param {indexName} uv-访客数 pv-浏览量 transNum-交易数 transUserNum-交易人数
   *                   turnoverUserNum-成交人数 turnoverNum-成交数 transAmount-成交额
   */
  getTransTrendOverview(params) {
    return _axiosMall.post('/data-center/trend-overview', params)
  },
  /**
   * 获取通知列表
   * @param {type} //1-通知助手 2-门店动态 3-审核消息
   * @param {bizUserId} 商家用户id
   * @param {pageSize}
   * @param {pageNum}
   * @param {status} //sent-未读列表 read-已读列表 不加 全部
   */
  getNoticeList(params) {
    return _axios.get('/message/list', {
      params
    });
  },
  /**
   * 批量更新通知已读
   * @param {ids} //通知主键 []
   */
  updateNotice(params) {
    return _axios.post('/message/update-all', params)
  },
  /**
   * 更新所有未读
   * @param {bizUserId}商家用户id
   */
  updateAllNotice() {
    return _axios.get('/message/set-read-all', {
      params
    })
  }
}


export default (Vue) => {
  VUE = Vue;
  VUE.prototype.$utils.extend(VUE.prototype.$api, API)
}



// WEBPACK FOOTER //
// ./src/api/admin.js